// Module
var code = "<span class=\"product-price__remark\" ng-show=\"withRemark\">*</span>";
// Exports
module.exports = code;